import { render } from "./CodeValidate.vue?vue&type=template&id=db8decd2&scoped=true"
import script from "./CodeValidate.vue?vue&type=script&lang=js"
export * from "./CodeValidate.vue?vue&type=script&lang=js"

import "./CodeValidate.vue?vue&type=style&index=0&id=db8decd2&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8decd2"]])

export default __exports__